import AppTitle from '@theme/components/atom/AppTitle'
import Container from '@theme/components/utils/Container'
import EmployeeBox from '@theme/components/content/EmployeeBox'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  mixins: [HeadingLevel],
  components: {
    AppTitle,
    Container,
    EmployeeBox,
  },
  props: {
    employees: {
      type: Array,
      required: true,
    },
    headingClass: {
      type: String,
      default: 'Title--alpha',
    },
  },
}
